import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled
          ? 'bg-cream-50/95 backdrop-blur-md border-b border-stone-200'
          : 'bg-cream-50/75 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20 md:h-24">
          <Link
            to="/"
            className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-300"
          >
            <img
              src="/images/udesign-mark-112.webp"
              alt="U Design Studio"
              width="112"
              height="112"
              fetchPriority="high"
              className="w-12 h-12 md:w-14 md:h-14 object-contain"
            />
            <span className="hidden sm:block font-sans text-sm tracking-[0.25em] uppercase whitespace-nowrap text-charcoal-700">
              U Design Studio
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative font-sans text-base tracking-wide transition-colors duration-300 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-charcoal-900'
                    : 'text-charcoal-600 hover:text-charcoal-900'
                }`}
              >
                {link.name}
                <span
                  className={`absolute -bottom-1 left-0 h-[1.5px] bg-terracotta-500 transition-all duration-300 ${
                    location.pathname === link.path ? 'w-full' : 'w-0'
                  }`}
                />
              </Link>
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center hover:text-terracotta-500 transition-colors duration-300 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl text-charcoal-700`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-cream-50/98 backdrop-blur-lg z-40 animate-fade-in">
          <div className="flex flex-col items-center justify-center h-full gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-serif text-3xl transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-terracotta-500'
                    : 'text-charcoal-800 hover:text-terracotta-500'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
